import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


const Majengo = () => {
  const { page } = useParams();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]); // Re-run effect when page changes

  return (
    <div className="bg-gray-600">
      <h1 className='text-center text-3xl py-4 text-white font-location'>MAJENGO</h1>
      <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 ">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-5 gap-3">

        <img src="gallery/majengo/majengo10.jpg" alt="majengo" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo11.jpg" alt="majengo" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo12.jpg" alt="majengo" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo13.jpg" alt="majengo" className={`w-full  rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo15.jpg" alt="majengo" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo18.jpg" alt="majengo" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo19.jpg" alt="majengo" className={`w-full rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo20.jpg" alt="majengo" className={`w-full rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo21.jpg" alt="majengo" className={`w-full rounded-md object-cover  h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo23.jpg" alt="majengo" className={`w-full pb-4 rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />
        <img src="gallery/majengo/majengo24.jpg" alt="majengo" className={`w-full pb-4  rounded-md object-cover h-72 transform hover:scale-90 transition-transform duration-500 ${loaded ? 'fade-in loaded' : ''}`} />

        </div>
      </div>
    </div>
  );
}

export default Majengo;
